import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { filter, map, Observable, switchMap, take } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectAuthLogingIn, selectAuthUser } from '../store/selectors/auth.selectors';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(
    private router: Router,
    private store: Store
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    const expectedRoles = route.data['roles'] as string[];

    return this.store.select(selectAuthLogingIn).pipe(
      filter((loaded) => loaded === false),
      switchMap(() => this.store.select(selectAuthUser).pipe(take(1))),
      take(1),
      map((user) => {
        if (!user) {
          return this.router.parseUrl('/login');
        }

        if (!user.role || (expectedRoles && !expectedRoles.includes(user.role))) {
          return this.router.parseUrl('/unauthorized');
        }

        return true;
      })
    );
  }
}
